export enum SpinnerType {
   Border = 'border',
   Growing = 'growing',
}

export enum SpinnerSize {
   small = 'small',
   medium = 'medium',
   large = 'large',
   larger = 'larger',
}

export enum SpinnerAlignment {
   TopCenter = 'TopCenter',
   Middle = 'Middle',
}

export enum SpinnerVariant {
   Primary = 'primary',
   Secondary = 'secondary',
   Success = 'success',
   Danger = 'danger',
   Warning = 'warning',
   Info = 'info',
   Light = 'light',
   Dark = 'dark',
}

export interface AtlSpinnerProps {
   internalClassName?: string;
   spinnerType?: SpinnerType;
   size: SpinnerSize;
   align?: SpinnerAlignment;
   variant?: SpinnerVariant;
}
